import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { DropdownService } from '../../services/dropdown.service';
import { UniversityService } from '../../services/university.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ValidationService } from '../../services/validation.service';
import { FilterByKeyAndValuePipe } from '../../pipes/filter-by-key-and-value.pipe';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';

@Component({
  selector: 'app-university-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FilterByKeyAndValuePipe, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, FormsModule, PluralPipe, AgGridListComponent, SelectInputComponent, SearchInputComponent, BulkUploadComponent, DropdownUploadButtonComponent],
  templateUrl: './university-list-page.component.html',
})

export class UniversityListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  page_name = 'University';
  form: FormGroup;
  params: any = {};
  selected_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;
  filter_country_id: any = null;
  filter_state_id: any = null;
  filter_district_id: any = null;
  last_grid_filter: any = {};

  city_cols: any = [
    { field: 'name', headerName: 'University Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    { field: 'City.name', headerName: 'City', filter: true, flex: 1, },
    {
      headerName: 'Contact', filter: true, flex: 2,
      cellStyle: { display: 'flex', alignItems: 'center' },
      cellRenderer: (params: any) => {
        const countryCode = params.data?.City?.District?.State?.country?.code || '';
        const contact = params.data?.contact || '';
        const email = params.data?.email || '';
        const prefix = countryCode ? (countryCode.startsWith('+') ? countryCode : `+${countryCode}`) : '';
        const displayContact = contact ? `${prefix}${contact}` : '';
        return `<div style="display:flex;flex-direction:column;justify-content:center;line-height:1.5">
          ${displayContact ? `<span style="font-weight:500;color:#111827;font-size:14px">${displayContact}</span>` : ''}
          ${email ? `<span style="color:#9CA3AF;font-size:13px">${email}</span>` : ''}
        </div>`;
      }
    },
    { field: 'address', headerName: 'Address', filter: true, flex: 1, },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];
  bulk_columns = [
    { column_name: 'Country Name', type: 'link', linked_list: 'country_list', linked_from: 'country', return_as: 'country_id', returning_key: 'id', sample_value: 'India' },
    { column_name: 'State Name', type: 'link', linked_list: 'state_list', return_as: 'state_id', returning_key: 'id', sample_value: 'Maharashtra' },
    { column_name: 'District Name', type: 'link', linked_list: 'district_list', returning_key: 'id', return_as: 'district_id', sample_value: 'Thane', skip_validation: true },
    { column_name: 'City Name', type: 'link', linked_list: 'city_list', returning_key: 'id', return_as: 'city_id', sample_value: 'Mumbai Suburban' },
    { column_name: 'University', type: 'text', return_as: 'name', sample_value: 'ABC University', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern },
    { column_name: 'Code', type: 'text', return_as: 'code', sample_value: 'MU', min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, regex: this.vs.code_pattern },
    { column_name: 'Email id', type: 'text', return_as: 'email', sample_value: 'mumbai.university@gmail.com', strict_validation: 'email', max_length: this.vs.max_length_email, regex: this.vs.email_pattern },
    { column_name: 'Contact Number', type: 'text', return_as: 'contact', sample_value: '9829398274', strict_validation: 'mobile', min_length: this.vs.min_length_contact, max_length: this.vs.max_length_contact, regex: this.vs.contact_pattern },
    { column_name: 'Address', type: 'text', return_as: 'address', sample_value: 'Vidya Nagari', min_length: this.vs.min_length_address, max_length: this.vs.max_length_address, regex: this.vs.address_pattern },
  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', tooltip: row.is_active ? 'Disable this item' : 'Enable this item', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_university_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_university_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_university_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete_modal_open.bind(this), permissions: this.gs.user_role_data?.masters_university_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public us: UniversityService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      address: ['', [Validators.required, Validators.minLength(this.vs.min_length_address), Validators.maxLength(this.vs.max_length_address), Validators.pattern(this.vs.address_pattern)]],
      country_id: ['', [Validators.required]],
      state_id: ['', [Validators.required]],
      district_id: ['', [Validators.required]],
      city_id: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.maxLength(this.vs.max_length_email), Validators.pattern(this.vs.email_pattern)]],
      contact: ['', [Validators.required, Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact), Validators.pattern(this.vs.contact_pattern)]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['country', 'state', 'city', 'distric']);
    this.ar.queryParams.subscribe(async (params: any) => {
      this.params = { ...params }
      await this.get_list(this.params)
    })
  }
  async get_list(filter?: any) {
    if (filter) this.last_grid_filter = filter;
    try {
      const params: any = { ...this.last_grid_filter };
      if (this.filter_country_id) params.country_id = this.filter_country_id;
      if (this.filter_state_id) params.state_id = this.filter_state_id;
      if (this.filter_district_id) params.district_id = this.filter_district_id;

      const res = await this.us.get_list(params);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching university list:", error);
    }
  }

  on_country_filter() {
    this.filter_state_id = null;
    this.filter_district_id = null;
    this.get_list({ ...this.last_grid_filter, page: 1, skip: 0 });
  }

  on_state_filter() {
    this.filter_district_id = null;
    this.get_list({ ...this.last_grid_filter, page: 1, skip: 0 });
  }

  on_district_filter() {
    this.get_list({ ...this.last_grid_filter, page: 1, skip: 0 });
  }
  download() {
    const data: any[] = (this.items as any)?.data || [];
    if (!data.length) return;
    const escape = (v: any) => { const s = String(v ?? ''); return s.includes(',') || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s; };
    let csv = 'Country,State,District,City,University,Code,Email,Contact,Address\n';
    for (const row of data) {
      csv += [
        escape(row.City?.District?.State?.country?.name),
        escape(row.City?.District?.State?.name),
        escape(row.City?.District?.name),
        escape(row.City?.name),
        escape(row.name),
        escape(row.code),
        escape(row.email),
        escape(row.contact),
        escape(row.address),
      ].join(',') + '\n';
    }
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'University_List.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  }

  async delete_modal_open(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }
  async delete_university() {
    try {
      let res = await this.us.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('university');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.us.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('university');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.us.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.ds.invalidate_dropdown_cache('university');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async open_form_modal(item?: any) {
    if (item?.id) {
      this.route.navigate(['/university/edit'], { queryParams: { id: item.id } });
    } else {
      this.route.navigate(['/university/add']);
    }
  }
  open_view_modal(item: any) {
    this.selected_ids = item;
    this.form.patchValue(item);
    this.view_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      delete form_value.country_id
      delete form_value.state_id
      delete form_value.district_id
      form_value.is_active = true;
      if (this.selected_ids && this.selected_ids.id) {
        let update_response = await this.us.update(this.selected_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.us.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('university');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        contact: item.contact + '',
        is_active: true,
      }));
      await this.gs.bulk_form_submission(updatedData, this.us, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }

  dropdownRegistry: { [depended: number]: any } = {};

  registerDropdown(event: { depended: number; ref: any }) {
    this.dropdownRegistry[event.depended] = event.ref;
  }

  onDropdownChange(event: { value: any, depended: number }) {
    console.log("Dropdown changed:", event);

    const current = event.depended;
    for (const key of Object.keys(this.dropdownRegistry).map(Number)) {
      if (key > current) {
        this.dropdownRegistry[key]?.reset();
      }
    }
  }


}
